export function FlagUkraine() {
	return (
		<svg
			width="24"
			height="24"
			viewBox="0 0 24 24"
			fill="none"
			className="flag-ukraine"
			xmlns="http://www.w3.org/2000/svg"
		>
			<g clipPath="url(#clip0_5542_10263)">
				<mask
					id="mask0_5542_10263"
					style={{ maskType: "luminance" }}
					maskUnits="userSpaceOnUse"
					x="1"
					y="4"
					width="22"
					height="16"
				>
					<path d="M1 4H22.3333V20H1V4Z" fill="white" />
				</mask>
				<g mask="url(#mask0_5542_10263)">
					<path
						fillRule="evenodd"
						clipRule="evenodd"
						d="M1 4V20H22.3333V4H1Z"
						fill="#3195F9"
					/>
					<mask
						id="mask1_5542_10263"
						style={{ maskType: "luminance" }}
						maskUnits="userSpaceOnUse"
						x="1"
						y="4"
						width="22"
						height="16"
					>
						<path
							fillRule="evenodd"
							clipRule="evenodd"
							d="M1 4V20H22.3333V4H1Z"
							fill="white"
						/>
					</mask>
					<g mask="url(#mask1_5542_10263)">
						<path
							fillRule="evenodd"
							clipRule="evenodd"
							d="M1 12V20H22.3333V12H1Z"
							fill="#FECA00"
						/>
					</g>
				</g>
			</g>
			<rect
				x="0.9"
				y="3.9"
				width="21.5333"
				height="16.2"
				rx="2.1"
				stroke="#B8B8B8"
				strokeWidth="0.2"
			/>
			<defs>
				<clipPath id="clip0_5542_10263">
					<rect x="1" y="4" width="21.3333" height="16" rx="2" fill="white" />
				</clipPath>
			</defs>
		</svg>
	);
}
